import { render, staticRenderFns } from "./UseWaterChange.vue?vue&type=template&id=625cb4fa&scoped=true"
import script from "./UseWaterChange.vue?vue&type=script&lang=js"
export * from "./UseWaterChange.vue?vue&type=script&lang=js"
import style0 from "./UseWaterChange.vue?vue&type=style&index=0&id=625cb4fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625cb4fa",
  null
  
)

export default component.exports